import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { OrderPreviewComponent } from '../order-preview/order-preview-component';
import { Order } from '../../interfaces/orders/order';

@Component({
    selector: 'lib-land-service-order-preview',
    templateUrl: './land-service-order-preview.component.html',
    styleUrl: './land-service-order-preview.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LandServiceOrderPreviewComponentComponent extends OrderPreviewComponent {
  @Input() order!: Order;
}
